require("!!/clarity-seed/node_modules/script-loader/addScript.js")(require("!!/clarity-seed/node_modules/raw-loader/index.js!/clarity-seed/node_modules/core-js/client/shim.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/core-js/client/shim.min.js
// module id = 491
// module chunks = 1